import $ from 'jquery'

$(document).ready(function()
{
    $('.materialize input').on('focus', function(){
        const $parent = $(this).parents('.materialize').eq(0)
        return $parent.addClass('filled')
    }).on('blur', function(){
        const $parent = $(this).parents('.materialize').eq(0)
        if ($(this).val().trim() === '') {
            return $parent.removeClass('filled')
        }
    })
})

$(window).on('load', function() {
    $('input').each(initFilled);
    // $('input:-webkit-autofill').each(autoFillFilled);
});

function initFilled() {
    $(this).parents('.materialize').eq(0).addClass('filled');

    if ($(this).attr('id') === 'username' && $(this).val() === '') {
        $(this).trigger('focus');
        // $(this).parents('.materialize').eq(0).addClass('filled');
        return;
    }
    if ($(this).attr('id') === 'password' && $('#username').val() !== '' && $(this).val() === '') {
        $(this).trigger('focus');
        // $(this).parents('.materialize').eq(0).addClass('filled')
        return;
    }
}

function autoFillFilled() {
    $(this).parents('.materialize').eq(0).addClass('filled');
}
